import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Clock, AlertCircle } from 'lucide-react';

export default function PeakFailureTimesChart({ data }) {
  if (!data?.hourlyDistribution) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center mb-4">
          <Clock className="w-6 h-6 text-orange-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Heures de Pic d'Échec</h3>
        </div>
        <p className="text-gray-500 text-center py-8">Aucune donnée disponible</p>
      </div>
    );
  }

  const chartData = data?.hourlyDistribution;
  const maxFailures = data?.maxFailures || 0;

  // Color bars based on failure count
  const getBarColor = (failures) => {
    if (failures === 0) return '#d1d5db'; // gray
    if (failures < maxFailures * 0.3) return '#fbbf24'; // yellow
    if (failures < maxFailures * 0.7) return '#f97316'; // orange
    return '#ef4444'; // red
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Clock className="w-6 h-6 text-orange-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Heures de Pic d'Échec</h3>
        </div>
      </div>

      {/* Peak Hours Alert */}
      {data?.peakHours && data?.peakHours?.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4 flex items-start">
          <AlertCircle className="w-5 h-5 text-red-600 mr-2 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-red-800">
              Heures de Pic: {data?.peakHours?.join(', ')}
            </p>
            <p className="text-xs text-red-600 mt-1">
              {maxFailures} échecs maximum pendant ces périodes
            </p>
          </div>
        </div>
      )}

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="hourLabel" 
            angle={-45} 
            textAnchor="end" 
            height={80}
            tick={{ fontSize: 10 }}
          />
          <YAxis />
          <Tooltip />
          <Bar dataKey="failures" name="Échecs">
            {chartData?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getBarColor(entry?.failures)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Stats Summary */}
      <div className="mt-4 grid grid-cols-2 gap-4">
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-600">Total Échecs</p>
          <p className="text-xl font-bold text-gray-900">{data?.totalFailures}</p>
        </div>
        <div className="bg-red-50 rounded-lg p-3">
          <p className="text-xs text-gray-600">Pic Maximum</p>
          <p className="text-xl font-bold text-red-600">{maxFailures} échecs</p>
        </div>
      </div>
    </div>
  );
}